<template>
  <v-container class="overlay-container" fluid>
    <transition name="fade">
      <div v-if="visible" class="overlay-content">
        <div class="background-eventbanner" v-if="!imgSrc && !isVideo && !isAvatarStyle">
          <v-img :src="eventbanner" alt="Overlay Hintergrund" />
          <div class="text-overlay event-text">{{ eventName }}</div>
          <div class="text-overlay user-text">{{ userName }}</div>
        </div>

        <div class="background-image" v-if="!isVideo">
          <v-img
            :src="imgSrc"
            alt="Overlay Bild"
            width="600"
            height="400"
            contain
            class="img-contained"
          />
          <div class="background-eventbanner" v-if="imgSrc && !isAvatarStyle">
            <v-img :src="eventbanner" alt="Overlay Hintergrund" />
            <div class="text-overlay event-text">{{ eventName }}</div>
            <div class="text-overlay user-text">{{ userName }}</div>
          </div>
        </div>

        <div class="background-image" v-else>
          <video
            ref="video"
            :src="audioSrc"
            autoplay
            muted
            playsinline
            width="600"
            height="400"
          ></video>
          <div class="background-eventbanner" v-if="!isAvatarStyle">
            <v-img :src="eventbanner" alt="Overlay Hintergrund" class="img-contained" />
            <div class="text-overlay event-text">{{ eventName }}</div>
            <div class="text-overlay user-text">{{ userName }}</div>
          </div>
        </div>

        <div class="background-image" v-if="!isVideo">
          <audio
            ref="audio"
            :src="audioSrc"
            preload="auto"
            autoplay
            muted
          >
            <track kind="captions" srclang="de" label="Deutsch" src="" />
          </audio>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="avatarPopupVisible" class="avatar-popup" :class="'avatar-popup--' + avatarPosition">
        <img :src="avatarUrl" class="avatar-popup-img" alt="Avatar" />
        <div class="avatar-popup-text">
          <div class="avatar-popup-username">{{ avatarUsername }}</div>
          <div class="avatar-popup-message-wrap" v-if="avatarMessage">
            <div
              class="avatar-popup-message"
              :class="{ scrolling: avatarMessageOverflows }"
              ref="avatarMessage"
            >{{ avatarMessage }}</div>
          </div>
        </div>
      </div>
    </transition>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      userName: '',
      eventName: '',
      audioSrc: '',
      imgSrc: '',
      isVideo: false,
      isAvatarStyle: false,
      avatarPopupVisible: false,
      avatarUrl: '',
      avatarUsername: '',
      avatarMessage: '',
      avatarMessageOverflows: false,
      avatarPosition: 'bottom-left',
      eventQueue: [],
      isPlaying: false,
      socket: null,
      hideTimeout: null,
      // eventbanner: `${process.env.VUE_APP_BACKEND_PROTOCOL}://${process.env.VUE_APP_WS_URL}:${process.env.VUE_APP_WS_PORT}/img/thofu_main/Soundalert_overlay_dark.png`,
      eventbanner: `${process.env.VUE_APP_BACKEND_PROTOCOL}://${process.env.VUE_APP_WS_URL}/img/thofu_main/Soundalert_overlay_dark.png`,
    };
  },
  mounted() {
    this.connectWebSocket();
  },
  methods: {
    connectWebSocket() {
      const sessionId = window.location.pathname.split('/').pop();
      // const wsUrl = `${process.env.VUE_APP_WS_PROTOCOL}://${process.env.VUE_APP_WS_URL}:${process.env.VUE_APP_WS_PORT}`;
      const wsUrl = `${process.env.VUE_APP_WS_PROTOCOL}://${process.env.VUE_APP_WS_URL}`;

      let heartbeatInterval = null;
      const reconnectDelay = 2000;

      const stopHeartbeat = () => {
        if (heartbeatInterval) {
          clearInterval(heartbeatInterval);
          heartbeatInterval = null;
        }
      };

      const startHeartbeat = () => {
        stopHeartbeat();
        heartbeatInterval = setInterval(() => {
          if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send('ping'); // Client sendet Ping
          }
        }, 10000);
      };

      const connect = () => {
        this.socket = new WebSocket(wsUrl);

        this.socket.addEventListener('open', () => {
          console.log('✅ WebSocket verbunden');
          this.socket.send(JSON.stringify({ cmd: 'init', id: sessionId, clientType: 'overlay' }));
          startHeartbeat();
        });

        this.socket.addEventListener('message', (event) => {
          if (event.data === 'pong') {
            // Pong vom Server → Verbindung lebt
            return;
          }

          let message;
          try {
            message = JSON.parse(event.data);
          } catch (err) {
            console.warn('⚠️ Ungültige Nachricht vom Server:', event.data);
            return;
          }

          if (message.cmd === 'redeem') {
            this.eventQueue.push(message);
            this.sortQueueByPriority();
            this.processQueue();
          }
        });

        this.socket.addEventListener('close', () => {
          console.log('⚠️ WebSocket geschlossen');
          stopHeartbeat();
          setTimeout(connect, reconnectDelay);
        });

        this.socket.addEventListener('error', (error) => {
          console.error('❌ WebSocket Fehler:', error);
          this.socket.close();
        });
      };

      connect();
    },
    sortQueueByPriority() {
      this.eventQueue.sort((a, b) => {
        const prioA = a.data?.priority ?? 0;
        const prioB = b.data?.priority ?? 0;
        return prioB - prioA;
      });
    },

    async processQueue() {
      if (this.isPlaying || this.eventQueue.length === 0) return;

      this.isPlaying = true;
      const message = this.eventQueue.shift();
      // const prefix = `${process.env.VUE_APP_BACKEND_PROTOCOL}://${process.env.VUE_APP_WS_URL}:${process.env.VUE_APP_WS_PORT}/img/`;
      const prefix = `${process.env.VUE_APP_BACKEND_PROTOCOL}://${process.env.VUE_APP_WS_URL}/img/`;

      this.userName = message.username || '';
      this.eventName = message.data.title || '';

      if (message.data.only_reward_img === 1) {
        this.imgSrc = '';
      } else if (message.data.img) {
        this.imgSrc = prefix + message.data.img;
      } else {
        this.imgSrc = '';
      }

      this.audioSrc = message.data.sound ? prefix + message.data.sound : '';
      this.isVideo = message.data?.soundtype === 'video';
      this.isAvatarStyle = message.data?.displayStyle === 'avatar';
      this.visible = true;

      if (this.isAvatarStyle) {
        this.avatarUrl = message.data.avatar || '';
        this.avatarUsername = message.username || '';
        this.avatarMessage = message.data.message || '';
        this.avatarPosition = message.data.position || 'bottom-left';
        this.avatarPopupVisible = true;
      }

      await this.$nextTick();

      if (this.isAvatarStyle) {
        const el = this.$refs.avatarMessage;
        this.avatarMessageOverflows = !!el && el.scrollWidth > el.parentElement.clientWidth;
      }

      if (this.isVideo) {
        const { video } = this.$refs;
        if (video) {
          video.muted = false;
          video.currentTime = 0;
          try {
            await video.play();
          } catch (err) {
            console.warn('Video Play Error:', err);
          }
        }
      } else {
        const { audio } = this.$refs;
        if (audio) {
          audio.muted = false;
          audio.currentTime = 0;
          try {
            await audio.play();
          } catch (err) {
            console.warn('Audio Play Error:', err);
          }
        }
      }

      const duration = message.data.soundduration || 3500;

      await new Promise((resolve) => {
        this.hideTimeout = setTimeout(() => {
          this.visible = false;
          this.avatarPopupVisible = false;
          this.avatarMessageOverflows = false;
          if (this.isVideo) {
            this.$refs.video?.pause();
          } else {
            this.$refs.audio?.pause();
          }
          resolve();
        }, duration);
      });

      this.isPlaying = false;
      this.processQueue();
    },
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  },
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.overlay-container {
  background: transparent !important;
  width: 1920px;
  height: 1055px;
  position: relative;
  overflow: hidden;
}

.overlay-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.background-eventbanner {
  position: absolute;
  top: 100px;
  left: 200px;
  width: 450px;
  height: auto;
}

.background-image {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 400px !important;

  .background-eventbanner {
    top: -160px;
    bottom: auto;
    left: 50%;
    transform: translateX(-50%);
  }
}

.text-overlay {
  position: absolute;
  color: white;
  font-size: 20px;
  font-weight: bold;
  text-shadow: 2px 2px 5px black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 300px;
  text-align: center;
}

.user-text {
  font-size: 15px;
  top: 75px;
  left: 115px;
  width: 300px;
}

.event-text {
  top: 35px;
  left: 115px;
  width: 300px;
}

.img-contained {
  background-color: transparent !important;
  object-fit: contain;
}

.v-main {
  overflow: hidden;
  height: 1080px;
}

.avatar-popup {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 12px;
  padding: 12px 20px 12px 12px;
  max-width: 480px;
}

.avatar-popup--bottom-left {
  bottom: 40px;
  left: 40px;
}

.avatar-popup--bottom-right {
  bottom: 40px;
  right: 40px;
}

.avatar-popup--top-left {
  top: 40px;
  left: 40px;
}

.avatar-popup--top-right {
  top: 40px;
  right: 40px;
}

.avatar-popup-img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.avatar-popup-text {
  color: white;
  text-shadow: 1px 1px 3px black;
}

.avatar-popup-username {
  font-size: 20px;
  font-weight: bold;
}

.avatar-popup-message-wrap {
  width: 320px;
  overflow: hidden;
  margin-top: 2px;
}

.avatar-popup-message {
  font-size: 16px;
  white-space: nowrap;
  display: inline-block;
}

.avatar-popup-message.scrolling {
  padding-left: 100%;
  animation: avatar-popup-marquee 8s linear infinite;
}

@keyframes avatar-popup-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
